<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
        <div slot="header">
          <strong v-if="this.$route.params.mode === 'edit'"> <i class="cui-note icons font-2xl mr-4"></i>Update Client Information</strong> 
          <strong v-else>Client Onbording </strong>          
        </div>
         
        <div class="box" v-if="seen" >
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-card-body>
              <b-row>
                <b-col md="6">

                  <b-form-group label="Client Name"  label-size="sm"
                    :label-cols="5" >                   
                     <b-form-input size="sm" v-on:keyup="clear1" type="text" v-model="client.name" name="client name" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.client name') }" placeholder="Enter Client Name">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.client name')" class="help is-danger">{{ errors.first('form-1.client name') }}</span>
                  </b-form-group>

                  <b-form-group label="Client ID"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-input  type="text" v-model="client.id" name="client id" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.client id') }" placeholder="Enter Client ID">
                    </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.client id')" class="help is-danger">{{ errors.first('form-1.client id') }}</span>
                  </b-form-group>
                  
                  <b-form-group label="Client Code"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-input class="input" v-on:keyup="clear1" type="text" v-model="client.code" value="" name="client code" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.client code') }" placeholder="Enter Client Code">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.client code')" class="help is-danger">{{ errors.first('form-1.client code') }}</span>
                  </b-form-group>

                  <b-form-group label="Client Country"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-select name="location type" v-model="client.country" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.client country') }" style="margin-left:-0px;">
                      <option :value="selected">--Select Country--</option>
                      <option value="dubai">Dubai</option>
                    </b-form-select>
                     <span style="text-align:left;" v-show="errors.has('form-1.client country')" class="help is-danger">{{ errors.first('form-1.client country') }}</span>
                  </b-form-group>                 
                  
                </b-col>
                <b-col md="6">

                  <b-form-group label="State"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-select v-model="client.state" name="state" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('form-1.state') }">
                        <option :value="selected">--Select--</option>
                        <option v-for="state in states">{{state}}</option>
                    </b-form-select>
                    <span style="text-align:left;" v-show="errors.has('form-1.state')" class="help is-danger">{{ errors.first('form-1.state') }}</span>
                  </b-form-group>  

                  <b-form-group label="City"  label-size="sm"
                    :label-cols="5" >                   
                     <b-form-input  type="text" v-model="client.city" name="city" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('form-1.city') }" placeholder="Enter City Name">
                    </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.city')" class="help is-danger">{{ errors.first('form-1.city') }}</span>
                  </b-form-group> 

                  <b-form-group label="IsActive"  label-size="sm"
                    :label-cols="5" >                   
                     <b-form-select name="isactive" v-model="client.isactive" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.isactive') }">
                        <option :value="selected">--Select--</option>
                        <option value="1">Active</option>
                        <option value="0">InActive</option>
                    </b-form-select>
                     <span style="text-align:left;" v-show="errors.has('form-1.isactive')" class="help is-danger">{{ errors.first('form-1.isactive') }}</span>
                  </b-form-group>

                  <b-form-group label="Access Token Key"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-input class="input" type="text" v-model="client.tokenkey" name="city" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.client tokenkey') }" placeholder="Enter Access Token Key">
                    </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.client tokenkey')" class="help is-danger">{{ errors.first('form-1.client tokenkey') }}</span>
                  </b-form-group>    
   
                </b-col> 
              </b-row>
              <div class="formHeader" style="height:50px;line-height:50px;margin-bottom:25px;background:	#17a2b8">
                <div style="float:left; padding-top:7px;">
                  <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px;margin-bottom:5px"><b>Configuration</b></h5>
                </div>
              </div>
              <b-row>
                  <b-col md="3">
                    <b-form-group label="Capture Image"  label-size="sm"
                      :label-cols="8" >                   
                      <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.isCaptureImage" name="isCaptureImage" v-bind:true-value="true"
                                  v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Dedicated SR's"  label-size="sm"
                      :label-cols="8" >                   
                      <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.dedicatedsr" name="dedicatedsr" v-bind:true-value="true" v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group> 

                    <b-form-group label="Fixed Pickup Locations"  label-size="sm"
                      :label-cols="8" >                   
                       <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.fixedpickuplocations" name="fixedpickuplocations" v-bind:true-value="true"
                                  v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group> 

                    <b-form-group label="Vendor Return"  label-size="sm"
                      :label-cols="8" >                   
                       <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.vendorreturn" name="vendorreturn" v-bind:true-value="true"
                                  v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group> 
                  </b-col>
                  <b-col md="3">

                    <b-form-group label="Multiproduct"  label-size="sm"
                      :label-cols="8" >                   
                      <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.multiproduct" name="multiproduct" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Allow re-attempt"  label-size="sm"
                      :label-cols="8" >                   
                      <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.allow_reattempt" name="allow_reattempt" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group> 

                    <b-form-group label="Slotted"  label-size="sm"
                      :label-cols="8" >                   
                       <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.slotted" name="slotted" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                     <b-form-group label="DirectHandover"  label-size="sm"
                      :label-cols="8" >                   
                       <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.directhandover" name="directhandover" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                  
                  </b-col>
                  <b-col md="3">

                    <b-form-group label="Allow Checked In"  label-size="sm"
                      :label-cols="8" >                   
                      <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.allowcheckedin" name="allowcheckedin" v-bind:true-value="true"
                                v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                     <b-form-group label="Allow SMS"  label-size="sm"
                      :label-cols="8" >                   
                        <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.allowsms" name="allowsms" v-bind:true-value="true"
                                v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Generate AWB"  label-size="sm"
                      :label-cols="8" >                   
                        <b-form-checkbox  class="checkbox" type="checkbox"  v-model="client.generateawb" name="generateawb" v-bind:true-value="true"
                              v-bind:false-value="false" @click="check">
                      </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Reject Order"  label-size="sm"
                      :label-cols="8" >                   
                         <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.rejectorder" name="rejectorder" v-bind:true-value="true" v-bind:false-value="false" @click="check">
                        </b-form-checkbox>                  
                    </b-form-group>

                    
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Auto check In"  label-size="sm"
                      :label-cols="8" >                   
                         <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.autocheckin" name="autocheckin" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                        </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Get Product Update"  label-size="sm"
                      :label-cols="8" >                   
                        <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.getprdupdate" name="getprdupdate" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                        </b-form-checkbox>                  
                    </b-form-group>

                    <b-form-group label="Show Sequence"  label-size="sm"
                      :label-cols="8" >                   
                        <b-form-checkbox class="checkbox" type="checkbox" v-model="client.showsequence" name="showsequence" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                        </b-form-checkbox>                  
                    </b-form-group>

                     <b-form-group label="Multi Pickup"  label-size="sm"
                      :label-cols="8" >                   
                         <b-form-checkbox class="checkbox" type="checkbox" v-model="client.multipickup" name="multipickup" v-bind:true-value="true"
                            v-bind:false-value="false" @click="check">
                        </b-form-checkbox>                  
                    </b-form-group>

                   
                  </b-col>
              </b-row>      
              <b-row>
                <b-col md="6">

                  <b-form-group label="Minimum Pickup Images"  label-size="sm"
                    :label-cols="5" >                   
                   <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.minpickupImages" name="client minimum pickup images" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.minimum pickup images') }" placeholder="Enter Minimum Pickup Images" min="0">
                    </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.client minimum pickup images')" class="help is-danger">{{ errors.first('form-1.client minimum pickup images') }}</span>
                  </b-form-group>

                  <b-form-group label="Maximum Pickup Images"  label-size="sm"
                    :label-cols="5" >                   
                      <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.maxpickupImages" name="client maximum pickup images" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.maximum pickup images') }" placeholder="Enter Maximum Pickup Images" min="0">
                    </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.client maximum pickup images')" class="help is-danger">{{ errors.first('form-1.client maximum pickup images') }}</span>
                  </b-form-group>

                  <b-form-group label="Minimum Drop Images"  label-size="sm"
                    :label-cols="5" >                   
                     <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.mindropImages" name="client minimum drop images" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.minimum drop images') }" placeholder="Enter Minimum Drop Images" min="0">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.client minimum drop images')" class="help is-danger">{{ errors.first('form-1.client minimum drop images') }}</span>
                  </b-form-group>                    
                </b-col>    
                <b-col md="6">
                  <b-form-group label="Maximum Drop Images"  label-size="sm"
                    :label-cols="5" >                   
                     <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.maxdropImages" name="client maximum drop images" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.maximum drop images') }" placeholder="Enter Maximum Drop Images" min="0">
                    </b-form-input>
                      <span style="text-align:left;" v-show="errors.has('form-1.client maximum drop images')" class="help is-danger">{{ errors.first('form-1.client maximum drop images') }}</span>
                  </b-form-group>

                  <b-form-group label="Maximum Idle Time"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.maxIdletime" name="client maximum idle time" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.client maximum idle time') }" placeholder="Enter maximum idle time" min="0">
                    </b-form-input>
                      <span style="text-align:left;" v-show="errors.has('form-1.client maximum idle time')" class="help is-danger">{{ errors.first('form-1.client maximum idle time') }}</span>
                  </b-form-group>

                   <b-form-group label="Push API"  label-size="sm"
                    :label-cols="5" >                   
                    <b-form-checkbox class="checkbox" type="checkbox"  v-model="client.pushapi" name="pushapi" v-bind:true-value="true"  v-bind:false-value="false" @click="check">
                    </b-form-checkbox>                     
                  </b-form-group>
                </b-col>    
              </b-row> 
              <div class="formHeader" style="height:50px;line-height:50px;margin-bottom:25px;background: #17a2b8">
                <div style="float:left; padding-top:7px;">
                  <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px;margin-bottom:5px"><b>SLA</b></h5>
                </div>
              </div>
              <b-row>
                <b-col md="6">
                    <b-form-group label="Pickup SLA"  label-size="sm"
                      :label-cols="5" >                   
                      <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.pickupSla" name="client pickup SLA" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.client pickup SLA') }" placeholder="Enter Client Pickup SLA" min="0" max="1440">
                      </b-form-input>
                      <span style="text-align:left;" v-show="errors.has('form-1.client pickup SLA')" class="help is-danger">{{ errors.first('form-1.client pickup SLA') }}</span>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Delivery SLA"  label-size="sm"
                      :label-cols="5" >                   
                      <b-form-input class="input" v-on:keyup="clear1" type="number" v-model="client.deliverySla" name="client delivery SLA" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.client delivery SLA') }" placeholder="Enter Client Delivery SLA" min="0" max="1440" >
                      </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.client delivery SLA')" class="help is-danger">{{ errors.first('form-1.client delivery SLA') }}</span>
                    </b-form-group>
                </b-col>                   
              </b-row>
            
             </b-card-body>
              <div slot="footer" class="text-right">
                <span v-if="this.$route.params.mode === 'edit'">
                  <b-button variant="primary" size="md" type="submit">Update</b-button>
                </span>
                <span v-else>
                 <b-button type="submit" size="md"  variant="primary">Submit</b-button>
                </span>
                <b-button  type="button" size="md" class="ml-4 mr-4" @click="clear" variant="danger">Clear</b-button>

              
              </div>
            </form>
        </div>
         </b-card> 
      </b-col>  
     </b-row>
   </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Router from 'vue-router'
export default {
  data: function() {
    return {
      name: 'pickuplocation',
      data: [],
      clientdata: [],
      customerSearch: {},
      seen: true,
      verificationCodeToggleInfo: false,
      selected:'',
      client: {
        name: '',
        id:'',
        code: '',
        country:'',
        state:'',
        city:'',
        isactive:'',
        tokenkey:'',
        config:{
          isCaptureImage:'',
          minpickupImages:'',
          maxpickupImages:'',
          mindropImages:'',
          maxdropImages:'',
          maxIdletime:'',
          pushapi:'',
          dedicatedsr:'',
          fixedpickuplocations:'',
          vendorreturn:'',
          multiproduct:'',
          slotted:'',
          allowcheckedin:'',
          allow_reattempt:'',
          directhandover: '',
          allowsms: '',
          generateawb:'',
          rejectorder:'',
          autocheckin:'',
          getprdupdate:'',
          showsequence:'',
          multipickup:''
        },
        sla:{
          pickupSla:'',
          deliverySla:''
        }

      },
      states: [
        'Abu Dhabi',
        'Al Ain',
        'Ajman',
        'Dubai',
        'Fujairah',
        'Ras Al Khaimah',
        'Sharjah',
        'Umm Al Quwain'
      ]
    }
  },
  created: function() {
    // this.displaydata()
    // this.displayclient()
  },
  mounted: function() {
    this.getClient()
  },
  methods: {
    validateForm(scope) {
    //  this.customer.pickuplonglat = this.longitude + ',' + this.latitude
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.onBoardClient()
        }
      })
    },
    check:function(){
    },
    getClient:function(){
      if (this.$route.params.id && this.$route.params.mode) {
        const obj = {
          clientmasterid: this.$route.params.id
        }
        this.$http
          .post(`${CONSTANTS.API_URL}/ClientMasterGetSingleRecord`, obj)
          .then(result => {
            let tempConfig=result.body[0].config;
            let tempsla=result.body[0].sla;
            this.client={
              name: result.body[0].clientname,
              id:result.body[0].clientid,
              code: result.body[0].clientcode,
              country:result.body[0].clientcountry,
              state:result.body[0].clientstate,
              city:result.body[0].clientcity,
              isactive:result.body[0].isactive,
              tokenkey:result.body[0].accesstokenkey,

              isCaptureImage:tempConfig.isCaptureImage,
              minpickupImages:tempConfig.minpickupImages,
              maxpickupImages:tempConfig.maxpickupImages,
              mindropImages:tempConfig.mindropImages,
              maxdropImages:tempConfig.maxdropImages,
              maxIdletime:tempConfig.maxIdletime,
              pushapi:tempConfig.pushapi,
              dedicatedsr:tempConfig.dedicatedsr,
              fixedpickuplocations:tempConfig.fixedpickuplocations,
              vendorreturn:tempConfig.vendorreturn,
              multiproduct:tempConfig.multiproduct,
              slotted:tempConfig.slotted,
              allowcheckedin:tempConfig.allowcheckedin,
              directhandover: tempConfig.directhandover,
              allow_reattempt:tempConfig.allow_reattempt,
              allowsms:tempConfig.allowsms,
              showsequence:tempConfig.showsequence,
              multipickup:tempConfig.multipickup,
              pickupSla:tempsla.pickupSla,
              deliverySla:tempsla.deliverySla,
              generateawb:tempConfig.generateawb,
              rejectorder:tempConfig.rejectorder,
              autocheckin:tempConfig.autocheckin,
              getprdupdate:tempConfig.getprdupdate

            }
          })
          .catch(ex => {
            console.log('error', ex)
          })
      }
    },
    clear1: function() {},
    onBoardClient: function() {
      let tempconfig={
        isCaptureImage:this.client.isCaptureImage,
        minpickupImages:this.client.minpickupImages,
        maxpickupImages:this.client.maxpickupImages,
        mindropImages:this.client.mindropImages,
        maxdropImages:this.client.maxdropImages,
        maxIdletime:this.client.maxIdletime,
        pushapi:this.client.pushapi,
        dedicatedsr:this.client.dedicatedsr,
        fixedpickuplocations:this.client.fixedpickuplocations,
        vendorreturn:this.client.vendorreturn,
        multiproduct:this.client.multiproduct,
        slotted:this.client.slotted,
        allowcheckedin:this.client.allowcheckedin,
        allow_reattempt:this.client.allow_reattempt,
        directhandover:this.client.directhandover,
        allowsms:this.client.allowsms,
        showsequence:this.client.showsequence,
        multipickup:this.client.multipickup,
        generateawb:this.client.generateawb,
        rejectorder:this.client.rejectorder,
        autocheckin:this.client.autocheckin,
        getprdupdate:this.client.getprdupdate
      }

      let tempsla={
        pickupSla:this.client.pickupSla,
        deliverySla:this.client.deliverySla
      }
      let clientInfo={
        name: this.client.name,
        id:this.client.id,
        code: this.client.code,
        country:this.client.country,
        state:this.client.state,
        city:this.client.city,
        isactive:this.client.isactive,
        tokenkey:this.client.tokenkey,
        config:JSON.stringify(tempconfig),
        sla:JSON.stringify(tempsla)
      }
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        clientInfo.lastmodifiedby = `${userInfo.sysemailid}`
        // console.log(clientInfo);
        if(this.$route.params.mode==="edit" && this.$route.params.id){

          clientInfo.clientmasterid=this.$route.params.id;
          this.$validator.validateAll().then(result => {
            if (result) {
              this.$http
                .post(
                  `${CONSTANTS.API_URL}/ClientMasterUpdate`,
                  clientInfo
                )
                .then(result => {
                
                  alert('Updated successfully', 'success')
                  this.$router.push('/clientOnboard/27/edit');
                  this.customer = {}
                  this.customer.country = 'dubai'
                  // this.displaydata()
                })
                .catch(ex => {
                  console.log('error', ex)
                })
              return
            } else {}
          })

        }
        else{

          this.$validator.validateAll().then(result => {
            if (result) {
              //console.log(clientInfo);
              this.$http
                .post(
                  `${CONSTANTS.API_URL}/ClientMasterAdd`,
                  clientInfo
                )
                .then(result => {
                  alert('Added successfully', 'success')
                  this.$router.push('/clientList');
                  this.customer = {}
                  this.customer.country = 'dubai'
                  // this.displaydata()
                })
                .catch(ex => {
                  console.log('error', ex)
                })
              return
            } else {}
          })

        }

    },
    clear: function() {
      this.client = {}
      this.errors.clear('form-1');
    },

  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>

